import { render, staticRenderFns } from "./DashboardQuickStats.vue?vue&type=template&id=b932cfec"
import script from "./DashboardQuickStats.vue?vue&type=script&lang=js"
export * from "./DashboardQuickStats.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports